/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from "vue"
import Vuex from "vuex"

// Store functionality
import actions from "./actions"
import getters from "./getters"
import modules from "./modules"
import mutations from "./mutations"
import state from "./state"

import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"
var ls = new SecureLS({ isCompression: false })

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "hmd_perfumist_app",
      paths: ["user", "brands", "notifications", "globalBrand"],
      storage: {
        getItem: key => {
          try {
            return ls.get(key)
          } catch (error) {
            console.log(error)
            return null
          }
        },
        setItem: (key, value) => {
          try {
            return ls.set(key, value)
          } catch (error) {
            console.log(error)
            return null
          }
        },
        removeItem: key => {
          try {
            return ls.remove(key)
          } catch (error) {
            console.log(error)
            return null
          }
        }
      }
    })
  ],
  actions,
  getters,
  modules,
  mutations,
  state
})

export default store
